import { Title } from '@nimbus-ds/components';
import { IonPageStratus, Responsive, Stack } from 'commons/components';
import {
  DomainsListDesktop,
  DomainsListMobile,
} from '../../DomainsListPage/components/DomainsList/components';

export function DomainsLandingPageSkeleton() {
  return (
    <IonPageStratus width="medium">
      <Stack column align="stretch" gap="3">
        <Title.Skeleton as="h5" />
        <Responsive
          mobile={<DomainsListMobile.Skeleton />}
          desktop={<DomainsListDesktop.Skeleton />}
        />
      </Stack>
    </IonPageStratus>
  );
}
